var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-intro"},[_vm._t("default",[_vm._v("This is intro")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }